import React, {Component} from "react";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import $ from 'jquery';
import "./Signin.scss";

class Signin extends Component {
    state = {
        modalOpen: false
    };
    settings = ConfigurationHelper.getSignInSettings();

    componentDidMount() {
        const that = this;
        const modalSelector = "#myModal";
        $(modalSelector).on("shown.bs.modal", function () {
            that.setState({
                modalOpen: true
            });
        });
        $(modalSelector).on("hidden.bs.modal", function () {
            that.setState({
                modalOpen: false
            });
        });
    }

    buttonStyles() {
        return {
            backgroundColor: this.settings.primary_color || "#000000",
            color: this.settings.secondary_color || "#FFFFFF",
            borderRadius: this.settings.button_border_radius || 0,
            textDecoration: "none"
        }
    }

    hoverIn(e) {
        e.currentTarget.style.color = this.settings.primary_color || "#000000";
    }

    hoverOut(e) {
        e.currentTarget.style.color = "#000000";
    }

    baseLink = () => {
        const { phpEnvName, clientHash } = ConfigurationHelper.getGlobalConfiguration();
        const env = phpEnvName === "app" ? "creator.creatable.io/" : `creator.${phpEnvName}.creatable.io/`;
        return "https://" + env + clientHash
    }
    loginLink = () => {
        const { phpEnvName } = ConfigurationHelper.getGlobalConfiguration();
        const env = phpEnvName === "app" ? "login.creatable.io/" : `login.${phpEnvName}.creatable.io/`;
        return "https://" + env;
    }
    applyLink = () => this.baseLink() + "/account/new";
    signInLink = () => this.loginLink() + `?continue=${this.baseLink()}/videos`;

    getPropertyOrDefault(origin, property, defaultValue) {
        if (origin && origin.hasOwnProperty(property))
            return origin[property];
        else if (defaultValue)
            return defaultValue;
        else
            return '';
    }

    createMarkup(text) {
        return {__html: text}
    }

    render() {
        const {modalOpen} = this.state;
        const settings = this.settings;
        const gradientValue = this.getPropertyOrDefault(settings.top_hero, 'hero_background_gradient');
        const backgroundGradient = gradientValue && gradientValue.length > 0 ? gradientValue+',' : '';
        return <div>
            <div className={"tvp-hero-image"} style={{
                backgroundImage: `${backgroundGradient}url(${this.getPropertyOrDefault(settings.top_hero, "hero_image")})`,
                color: settings.secondary_color || '#ffffff'
            }}>
                <div className={"container tvp-hero-tile"}>
                    <div className={"tvp-hero-text"}>
                        {(settings.top_hero && settings.top_hero.hero_text_1) &&
                        <div className={"tvp-hero-text-top"}
                             style={{
                                 color: `url(${this.getPropertyOrDefault(settings.top_hero, "hero_text_1_color", "#fff")})`,
                                 textShadow: this.getPropertyOrDefault(settings.top_hero, "hero_text_1_shadow", "none")
                             }}
                             dangerouslySetInnerHTML={this.createMarkup(settings.top_hero.hero_text_1)}/>
                        }
                        {(settings.top_hero && settings.top_hero.hero_text_2) &&
                        <div className={"tvp-hero-text-middle"}
                             style={{
                                 color: `url(${this.getPropertyOrDefault(settings.top_hero, "hero_text_2_color", "#fff")})`,
                                 textShadow: this.getPropertyOrDefault(settings.top_hero, "hero_text_2_shadow", "none")
                             }}>
                            {settings.top_hero.hero_text_2}
                        </div>}
                        {(settings.top_hero && settings.top_hero.hero_text_3) &&
                        <div className={"tvp-hero-text-bottom"}
                             style={{
                                 color: `url(${this.getPropertyOrDefault(settings.top_hero, "hero_text_3_color", "#fff")})`,
                                 textShadow: this.getPropertyOrDefault(settings.top_hero, "hero_text_3_shadow", "none")
                             }}>
                            {settings.top_hero.hero_text_3}
                        </div>}
                        <div className={"tvp-hero-buttons"}>
                            {(settings.top_hero && settings.top_hero.hero_video_embed) &&
                            <button data-toggle="modal" data-target="#myModal"
                                    style={this.buttonStyles()}>
                                <i className={"triangle"}> </i> WATCH NOW
                            </button>}
                            <a href={this.applyLink()} target={"_blank"} style={this.buttonStyles()}
                               role={"button"}>{settings.apply_text}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container"}>
                <div className={"sign-in-link"}>
                    <div className={"text-center sign-in-link-redirect"}>
                        Already an ambassador? <a target={"_blank"}
                                                  onMouseEnter={this.hoverIn.bind(this)}
                                                  onMouseLeave={this.hoverOut.bind(this)}
                                                  onTouchStart={this.hoverIn.bind(this)}
                                                  onTouchEnd={this.hoverOut.bind(this)}
                                                  href={this.signInLink()}>Sign in</a>
                    </div>
                </div>
            </div>
            <div className={"container"}>
                <div className={"tvp-mobile-apps"}>
                    <div className={"text-center download-text"}>
                        DOWNLOAD THE MOBILE APP
                    </div>
                    <div className={"tvp-mobile-apps-holder"}>
                        <div className="apps">
                            <a href="https://apps.apple.com/us/app/storefront-by-tvpage/id1518518652"
                               className="apps-ios">
                                <img
                                    src="https://d33wubrfki0l68.cloudfront.net/8a2d00415725348aa48f368e797360a50aee43a2/4a10c/wp-content/themes/iambassador/img/apple-app-store.svg"
                                    alt="Creatable IOS app"/>
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=com.tvpage.storefront&amp;hl=en_US"
                               className="apps-android">
                                <img
                                    src="https://d33wubrfki0l68.cloudfront.net/52be3a706c5c515f5f908b5762db9a61bf42c50b/12f71/wp-content/themes/iambassador/img/google-app-store.png"
                                    alt="Creatable Android app"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container tvp-program-invite"}>
                <div className={"row justify-content-between align-items-center"}>
                    <div className={"col-12 col-sm-5"}>
                        <div className="embed-responsive embed-responsive-1by1">
                            <div className={"embed-responsive-item tvp-program-invite-banner"} style={{
                                backgroundImage: `url(${this.getPropertyOrDefault(settings.program_feature, "feature_image")})`,
                                borderRadius: this.getPropertyOrDefault(settings.program_feature, "feature_image_radius", 0)
                            }}>

                            </div>
                        </div>

                    </div>
                    <div className={"col-12 col-sm-6 offset-sm-1"}>
                        <div className={"tvp-program-invite-holder"}>
                            {(settings.program_feature && settings.program_feature.feature_title) &&
                            <div className={"tvp-program-invite-holder-title"}
                                 dangerouslySetInnerHTML={this.createMarkup(settings.program_feature.feature_title)}/>
                            }
                            {(settings.program_feature && settings.program_feature.feature_description) &&
                            <div className={"tvp-program-invite-holder-description"}
                                 dangerouslySetInnerHTML={this.createMarkup(settings.program_feature.feature_description)}/>
                            }
                            <div className={"tvp-program-invite-holder-apply tvp-hero-buttons"}>
                                <a role={"button"} href={this.applyLink()} target={"_blank"} style={this.buttonStyles()}>
                                    {settings.apply_text}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container tvp-program-benefits"}>
                <div className={"row justify-content-between align-items-center"}>

                    <div className={"col-12 col-sm-5 order-sm-1 offset-sm-1"}>
                        <div className="embed-responsive embed-responsive-1by1">
                            <div className={"embed-responsive-item tvp-program-benefits-banner"} style={{
                                backgroundImage: `url(${this.getPropertyOrDefault(settings.program_benefits, "benefits_image")})`,
                                borderRadius: this.getPropertyOrDefault(settings.program_benefits, "benefits_image_radius", 0)
                            }}>

                            </div>
                        </div>
                    </div>

                    <div className={"col-12  col-sm-6"}>
                        <div className={"tvp-program-benefits-holder"}>
                            {(settings.program_benefits && settings.program_benefits.benefits_title) &&
                            <div className={"tvp-program-benefits-holder-title"}
                                 dangerouslySetInnerHTML={this.createMarkup(settings.program_benefits.benefits_title)}/>
                            }
                            <div className={"tvp-program-benefits-holder-list"}>
                                <ul>
                                    {
                                        (settings.program_benefits && settings.program_benefits.benefit_1) && <li>
                                            <span>{settings.program_benefits.benefit_1}</span>
                                            <span>{settings.program_benefits.benefit_description_1}</span>
                                        </li>
                                    }
                                    {
                                        (settings.program_benefits && settings.program_benefits.benefit_2) && <li>
                                            <span>{settings.program_benefits.benefit_2}</span>
                                            <span>{settings.program_benefits.benefit_description_2}</span>
                                        </li>
                                    }
                                    {
                                        (settings.program_benefits && settings.program_benefits.benefit_3) && <li>
                                            <span>{settings.program_benefits.benefit_3}</span>
                                            <span>{settings.program_benefits.benefit_description_3}</span>
                                        </li>
                                    }
                                    {
                                        (settings.program_benefits && settings.program_benefits.benefit_4) && <li>
                                            <span>{settings.program_benefits.benefit_4}</span>
                                            <span>{settings.program_benefits.benefit_description_4}</span>
                                        </li>
                                    }
                                    {
                                        (settings.program_benefits && settings.program_benefits.benefit_5) && <li>
                                            <span>{settings.program_benefits.benefit_5}</span>
                                            <span>{settings.program_benefits.benefit_description_5}</span>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className={"container"}>
                <div className={"tvp-payments"}>
                    <div className={"row"}>
                        <div className={"col-12 col-sm-6"}>
                            <div className={"tvp-payments-title"}>{settings.payment_terms.payment_title}</div>
                            <p>{settings.payment_terms.payment_description}</p>
                        </div>
                        <div className={"col-12 col-sm-6"}>
                            <div className={"tvp-payments-rules"}>
                                <span className={"font-weight-bold"}>Payment Type: </span>{settings.payment_terms.payment_type}
                            </div>
                            <div className={"tvp-payments-rules"}>
                                <span className={"font-weight-bold"}>Payment Rate: </span>{settings.payment_terms.payment_rate}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container"}>
                <div className={"tvp-hero-buttons tvp-last-button"}>
                    <a target={"_blank"} href={this.applyLink()} style={this.buttonStyles()}
                       role={"button"}>{settings.apply_text}</a>
                </div>
            </div>


            <div className="modal fade" id="myModal" tabIndex="-1" role="dialog"
                 aria-labelledby="myModalLabel">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="embed-responsive embed-responsive-16by9 iframe-container">
                                {modalOpen && <iframe frameBorder="0" allowFullScreen=""
                                                      sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                                                      className={"embed-responsive-item"}
                                                      src={settings.top_hero.hero_video_embed}>

                                </iframe>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    }
}

export default Signin;
